'use strict';
'use es6';

/**
 * Build an error object.
 *
 * @example
 * const myError = buildError('its broken', { usefulDataThatWillReportToSentry: true }, { moreUsefulData: 'is good' });
 *
 * @param {String} message - error message
 * @param {...Object} errorProps - props to add to the error
 *
 * @return {Error}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var buildError = exports.buildError = function buildError(message) {
  for (var _len = arguments.length, errorProps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    errorProps[_key - 1] = arguments[_key];
  }

  return Object.assign.apply(Object, [new Error()].concat(errorProps, [{ message: message }]));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-infrastructure/static-1.19/js/errors/builders/buildError.js
// module id = 186
// module chunks = 2 3